// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from 'react';

export const rpgState = [
    'offline',
    'wait',
    'play',
    'investigate',
    'battle',
    'finish'
]

export const StylesGroup = [
    { title: 'Ação' },
    { title: 'Investigação' },
    { title: 'Batalha' },
    { title: 'Terror' },
    { title: 'Comédia' },
    { title: 'Relaxar' },
    { title: 'Calmo' },
    { title: 'Agitado' },
    { title: 'Nojento' },
    { title: 'Fofo' },
    { title: 'Romântico' },
    { title: 'Exploração' },
    { title: 'Épico' },
    { title: 'Sobrenatural' },
    { title: 'Psicológico' },
    { title: 'Histórico' },
    { title: 'Fantasia Sombria' },
    { title: 'Espionagem' },
    { title: 'Survival' },
    { title: 'Drama' },
    { title: 'Steampunk' },
    { title: 'Cyberpunk' },
]

export const Dices = [100, 60, 20, 12, 10, 8, 6, 4, 2];

export const randomColors = [
    0,        
    1752220,  
    1146986,  
    5763719,  
    2067276,  
    3447003,  
    2123412,  
    10181046, 
    7419530,  
    15277667, 
    11342935, 
    15844367, 
    12745742, 
    15105570, 
    11027200, 
    15548997, 
    10038562, 
    9807270,  
    9936031,  
    8359053,  
    12370112, 
    3426654,  
    2899536,  
    16776960, 
];